var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tabber_offer_unselected.99ec22ef.png","uri@3x": __webpack_public_path__ + "static/media/tabber_offer_unselected.47678a8a.png","uri@2x": __webpack_public_path__ + "static/media/tabber_offer_unselected.bc6a28f9.png",
    width: 24,
    height: 24
});